import React from 'react'

import { Element, TextLink, TextLinkProps } from "components/shared/base"
import { colors } from "theme/colors"

const NavigationItem: React.FC<TextLinkProps> = ({
  href,
  text
}): React.ReactElement => {
  return (
    <Element as="li" fontWeight="700" mb="5px" >
      <TextLink color={colors.textFooter} href={href} text={text} />
    </Element>
  )
}

export default NavigationItem
